import React from 'react';
import MaterialTable from "@material-table/core";
import { ExportCsv } from '@material-table/exporters';
import parseDataTable from './parseDataTable';
//import jsPDF from 'jspdf';
const { jsPDF } = require("jspdf");
require('jspdf-autotable');


export default function TableModule({ JSONData, optionsTable, setIsLoading }) {
  
  const exportPdf = (data, columns, tableTitle) => {
    const doc = new jsPDF();
  
    const columnTitles = columns
        .map(columnDef => columnDef.title);
    
    const pdfData = data.map(rowData =>
          columns.map(columnDef => rowData[columnDef.field]),
        );

    doc.autoTable({
       head: [columnTitles],
       body: pdfData,
       pageBreak: 'auto',
       horizontalPageBreak: true,
       horizontalPageBreakRepeat: 0,
       styles: {columnWidth: 'wrap'},
       columnStyles: {text: {cellWidth: 'auto'}}
       //margin: {top: 50, right: 50, bottom: 50, left: 50},
    });
  
    doc.save(tableTitle);
  };

  const processedData = parseDataTable(JSONData);

  let options = {
    exportMenu: [{
      label: 'Exportar tabla en PDF',
      exportFunc: (cols, datas) => exportPdf(datas, cols, 'odisea-lista')
    }, {
      label: 'Exportar tabla en CSV',
      exportFunc: (cols, datas) => ExportCsv(cols, datas, 'odisea-lista')
    }],
    pageSize: 10,
    pageSizeOptions: [10, 50, processedData?.data && processedData.data.length],
    headerStyle: {color: '#000', fontWeight: 'bold'},
    isLoading: true,
    exportAllData: true
  }

  if (optionsTable) {
    options = {
      ...options,
      ...optionsTable
    }
  }

  return (
    <div style={{ maxWidth: "100%" }}>
      <MaterialTable
        columns={ processedData.columns }
        data={ processedData.data }
        title={ processedData.title }
        options={ options }
        localization={{
          toolbar: {
            searchPlaceholder: 'Búsqueda'
          },
      }}
      />
    </div>
  )
}
